import React from 'react';
import * as classes from './MapLegend.module.scss';
import { useTranslation } from 'gatsby-plugin-react-i18next';

interface Props {
  primaryLocationMarkerIcon: string;
  otherLocationsMarkerIcon: string;
}

const MapLegend = ({ otherLocationsMarkerIcon, primaryLocationMarkerIcon }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={classes.wrapper}>
      <div className={classes.item}>
        <img src={primaryLocationMarkerIcon} alt='' />
        <div className={classes.text}>{t('services.locationsSection.mapLegend.primaryLocation')}</div>
      </div>
      <div className={classes.item}>
        <img src={otherLocationsMarkerIcon} alt='' />
        <div className={classes.text}>{t('services.locationsSection.mapLegend.locations')}</div>
      </div>
      <div className={classes.item}>
        <div className={classes.radius} />
        <div className={classes.text}>{t('services.locationsSection.mapLegend.travelRadius')}</div>
      </div>
    </div>
  );
};

export default MapLegend;
